import React from "react";
import { Card } from "@/CommonElements/Hajj/Card";
import { useTranslation } from "react-i18next";
import { STACK_4 } from "./PilgrimDetails";
import { LabelValue } from "@Component/Value";

export const ArrivalDepartureData = (props) => {
  const { t } = useTranslation();
  const { isLoading } = props;

  const {
    entry_port,
    expected_arrival_date,
    flight_number,
    actual_arrival_date,
    direction,
    exit_port,
    expected_departure_date,
    departure_direction,
    actual_departure_date,
    nusuk_departure_report_number,
    departure_confirmation_nusuk,
  } = props;

  const VerticalLabelValue = (props) => {
    return <LabelValue loading={isLoading} direction="vertical" {...props} />;
  };

  return (
    <Card header={<span className="H5">{t("ARRIVAL_DEPARTURE_DATA")}</span>}>
      <STACK_4>
        <VerticalLabelValue label={t("ENTRY_PORT")} value={entry_port || "-"} />
        <VerticalLabelValue
          label={t("EXPECTED_ARRIVAL_DATE")}
          value={expected_arrival_date || "-"}
        />
        <VerticalLabelValue
          label={t("FLIGHT_NUMBER")}
          value={flight_number || "-"}
        />
        <VerticalLabelValue
          label={t("ACTUAL_ARRIVAL_DATE")}
          value={actual_arrival_date || "-"}
        />
        <VerticalLabelValue label={t("DIRECTION")} value={direction || "-"} />
        <VerticalLabelValue label={t("EXIT_PORT")} value={exit_port || "-"} />
        <VerticalLabelValue
          label={t("EXPECTED_DEPARTURE_DATE")}
          value={expected_departure_date || "-"}
        />
        <VerticalLabelValue
          label={t("DEPARTURE_DIRECTION")}
          value={departure_direction || "-"}
        />
        <VerticalLabelValue
          label={t("ACTUAL_DEPARTURE_DATE")}
          value={actual_departure_date || "-"}
        />
        <VerticalLabelValue
          label={t("NUSUK_DEPARTURE_REPORT_NUMBER")}
          value={nusuk_departure_report_number || "-"}
        />
        <VerticalLabelValue
          label={t("DEPARTURE_CONFIRMATION_NUSUK")}
          value={departure_confirmation_nusuk || "-"}
        />
      </STACK_4>
    </Card>
  );
};
